import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { getjobById } from "../../service/api";

const THEME = "#DC4C64";

const FieldBox = ({ label, value, icon }) => (
  <div style={{ display: "flex", alignItems: "flex-start", gap: "9px", padding: "8px 12px", background: "#fff", border: "1px solid #f5eded", borderRadius: "8px" }}>
    <div style={{ width: "26px", height: "26px", borderRadius: "6px", background: "#fff5f7", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: "1px" }}>
      <i className={`mdi ${icon}`} style={{ color: THEME, fontSize: "13px" }} />
    </div>
    <div style={{ minWidth: 0 }}>
      <div style={{ fontSize: "9px", fontWeight: "700", color: "#bbb", textTransform: "uppercase", letterSpacing: "0.5px" }}>{label}</div>
      <div style={{ fontSize: "12px", fontWeight: "600", color: "#333", marginTop: "1px", wordBreak: "break-word" }}>
        {value || <span style={{ color: "#ccc", fontWeight: "400" }}>—</span>}
      </div>
    </div>
  </div>
);

const SectionHeader = ({ icon, title }) => (
  <div style={{ display: "flex", alignItems: "center", gap: "7px", marginBottom: "10px", paddingBottom: "7px", borderBottom: "2px solid #fde8e8" }}>
    <i className={`mdi ${icon}`} style={{ color: THEME, fontSize: "16px" }} />
    <span style={{ fontSize: "11px", fontWeight: "800", color: "#444", textTransform: "uppercase", letterSpacing: "0.7px" }}>{title}</span>
  </div>
);

const Fullviewjobform = () => {
  const { id } = useParams();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getjobById(id);
        setJob(response.data);
      } catch (error) {
        console.error("Error fetching job data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  if (loading) return <div className="page-content"><p>Loading...</p></div>;
  if (!job) return <div className="page-content"><p>Job not found.</p></div>;

  const p = job.patientID || {};
  const formatDate = (d) => d ? new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" }) : "—";

  return (
    <>
      <style>{`
        @media print {
          body * { visibility: hidden !important; }
          #job-print, #job-print * { visibility: visible !important; }
          #job-print { position: fixed; top: 0; left: 0; width: 100%; }
          .no-print { display: none !important; }
        }
      `}</style>

      <div className="page-content">
        <div className="container-fluid">

          {/* Toolbar */}
          <div className="d-flex justify-content-between align-items-center mb-3 no-print">
            <h5 style={{ margin: 0, fontWeight: "700", color: "#333" }}>Job Form Details</h5>
            <div style={{ display: "flex", gap: "8px" }}>
              <button
                onClick={() => window.print()}
                style={{ background: THEME, color: "#fff", border: "none", borderRadius: "7px", padding: "6px 16px", fontWeight: "600", fontSize: "13px", display: "flex", alignItems: "center", gap: "5px", cursor: "pointer" }}
              >
                <i className="mdi mdi-printer" /> Print
              </button>
              <Link to="/job" style={{ background: "#f5f5f5", color: "#555", borderRadius: "7px", padding: "6px 16px", fontWeight: "600", fontSize: "13px", display: "flex", alignItems: "center", gap: "5px", textDecoration: "none" }}>
                <i className="mdi mdi-arrow-left" /> Back
              </Link>
            </div>
          </div>

          {/* Printable Card */}
          <div id="job-print" style={{ background: "#fff", borderRadius: "12px", overflow: "hidden", border: "1px solid #f0e8e8", boxShadow: "0 3px 16px rgba(220,76,100,0.08)" }}>

            {/* Header */}
            <div style={{ background: `linear-gradient(135deg, ${THEME} 0%, #c0392b 100%)`, padding: "18px 24px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "12px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <div style={{ width: "42px", height: "42px", borderRadius: "10px", background: "rgba(255,255,255,0.2)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <i className="mdi mdi-glasses" style={{ color: "#fff", fontSize: "22px" }} />
                </div>
                <div>
                  <div style={{ fontSize: "16px", fontWeight: "800", color: "#fff" }}>{job.practisc_name || "Eye Care Practice"}</div>
                  <div style={{ fontSize: "11px", color: "rgba(255,255,255,0.75)" }}>Optical Job Card</div>
                </div>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                <div style={{ textAlign: "right" }}>
                  <div style={{ fontSize: "9px", color: "rgba(255,255,255,0.7)", textTransform: "uppercase", letterSpacing: "1px" }}>VC Reference</div>
                  <div style={{ fontSize: "15px", fontWeight: "800", color: "#fff", fontFamily: "monospace", letterSpacing: "1px" }}>{job.vc_reference || "—"}</div>
                </div>
                <div style={{ background: "rgba(255,255,255,0.2)", border: "1px solid rgba(255,255,255,0.35)", borderRadius: "20px", padding: "4px 12px", fontSize: "11px", fontWeight: "700", color: "#fff" }}>
                  ● {job.lens_type || "Job"}
                </div>
              </div>
            </div>

            {/* Quick Stats Bar */}
            <div style={{ background: "#fdf8f8", borderBottom: "1px solid #f5eded", padding: "12px 24px", display: "flex", gap: "8px", flexWrap: "wrap" }}>
              {[
                { icon: "mdi-calendar", label: "Date", value: formatDate(job.date) },
                { icon: "mdi-barcode", label: "VC Reference", value: job.vc_reference },
                { icon: "mdi-eye-outline", label: "Lens Type", value: job.lens_type },
                { icon: "mdi-eyeglass-outline", label: "Frame Supplied", value: job.frame },
                { icon: "mdi-flask-outline", label: "Surfacing Lab", value: job.surfacing_lab },
              ].map((item, i) => (
                <div key={i} style={{ display: "flex", alignItems: "center", gap: "8px", background: "#fff", border: "1px solid #f5eded", borderRadius: "8px", padding: "7px 14px", flex: "1 1 140px" }}>
                  <i className={`mdi ${item.icon}`} style={{ color: THEME, fontSize: "16px", flexShrink: 0 }} />
                  <div>
                    <div style={{ fontSize: "9px", color: "#bbb", textTransform: "uppercase", fontWeight: "700" }}>{item.label}</div>
                    <div style={{ fontSize: "12px", fontWeight: "700", color: "#333" }}>{item.value || "—"}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* Body */}
            <div style={{ padding: "18px 24px", display: "flex", flexDirection: "column", gap: "18px" }}>

              {/* Practice Info */}
              <div>
                <SectionHeader icon="mdi-hospital-building" title="Practice Information" />
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "8px" }}>
                  <FieldBox icon="mdi-office-building-outline" label="Practice Name" value={job.practisc_name} />
                  <FieldBox icon="mdi-card-account-details-outline" label="Practice Number" value={job.practisc_number} />
                  <FieldBox icon="mdi-map-marker-outline" label="Practice Address" value={job.practisc_address} />
                  <FieldBox icon="mdi-phone-outline" label="Practice Phone" value={job.practisc_mobilenum} />
                  {job.Optum && <FieldBox icon="mdi-tag-outline" label="Referral" value={job.Optum} />}
                </div>
              </div>

              {/* Patient Info */}
              <div>
                <SectionHeader icon="mdi-account-circle-outline" title="Patient Information" />
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "8px" }}>
                  <FieldBox icon="mdi-account" label="Full Name" value={`${p.title ? p.title + ". " : ""}${p.firstname || ""} ${p.lastname || ""}`.trim()} />
                  <FieldBox icon="mdi-card-account-details-outline" label="MPI No." value={p.mpino} />
                  <FieldBox icon="mdi-phone-outline" label="Contact No." value={job.contactno || p.mobile} />
                  <FieldBox icon="mdi-gender-male-female" label="Gender" value={p.gender} />
                  <FieldBox icon="mdi-cake-variant-outline" label="Date of Birth" value={formatDate(p.dob)} />
                  <FieldBox icon="mdi-numeric" label="Age" value={p.age} />
                  {p.idnumber && <FieldBox icon="mdi-identifier" label="ID Number" value={p.idnumber} />}
                  {p.email && <FieldBox icon="mdi-email-outline" label="Email" value={p.email} />}
                </div>
              </div>

              {/* Job Details */}
              <div>
                <SectionHeader icon="mdi-clipboard-text-outline" title="Job Details" />
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "8px" }}>
                  <FieldBox icon="mdi-eye-outline" label="Lens Type" value={job.lens_type} />
                  <FieldBox icon="mdi-eyeglass-outline" label="Frame Supplied" value={job.frame} />
                  {job.frame_type && <FieldBox icon="mdi-glasses" label="Frame Type" value={job.frame_type} />}
                  <FieldBox icon="mdi-flask-outline" label="Surfacing Lab" value={job.surfacing_lab} />
                  <FieldBox icon="mdi-account-tie-outline" label="Faculty Manager" value={job.faculty} />
                </div>
              </div>

              {/* Notes */}
              {job.notes && (
                <div style={{ background: "#fffbf0", border: "1px solid #fde8b0", borderRadius: "8px", padding: "10px 14px" }}>
                  <div style={{ fontSize: "10px", fontWeight: "700", color: "#b8860b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "4px" }}>
                    <i className="mdi mdi-note-text-outline me-1" />Notes
                  </div>
                  <div style={{ fontSize: "13px", color: "#555" }}>{job.notes}</div>
                </div>
              )}
            </div>

            {/* Footer */}
            <div style={{ background: "#fdf8f8", borderTop: "1px solid #f5eded", padding: "10px 24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ fontSize: "11px", color: "#bbb", display: "flex", alignItems: "center", gap: "5px" }}>
                <i className="mdi mdi-glasses" style={{ color: "#ddd" }} />
                {job.practisc_name} — Optical Job Card
              </div>
              <div style={{ fontSize: "10px", color: "#ccc", fontFamily: "monospace" }}>Ref: {job.vc_reference}</div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default Fullviewjobform;
